// https://docs.google.com/spreadsheets/d/1O2AbgZ4DlkuXegEOcfRbcb71pKRFPt3CgGDLFw8vlpQ/edit#gid=2073249340

// #10
export function exitModalPageLoadEvent (track, language) {
  const trackingData = {
    event: 'navigate',
    componentType: 'exit-pop-up',
    action: 'view',
    title: 'exit-pop-up',
    virtualPageURL: `${language}/exit-pop-up`,
  };

  track({ data: trackingData });
}

// #11
export function exitModalSignupLoginBtnClickEvent (track, language) {
  const trackingData = {
    event: 'signupNow',
    componentType: 'exit-pop-up',
    position: 1,
    virtualPageURL: `${language}/exit-pop-up`,
  };

  track({ data: trackingData });
}

// #12
export function exitModalLearnMoreClickEvent (track, language) {
  const trackingData = {
    event: 'navigate',
    componentType: 'exit-pop-up',
    action: 'click',
    title: 'learn-more',
    virtualPageURL: `${language}/exit-pop-up`,
  };

  track({ data: trackingData });
}

// #13
export function exitModalCloseEvent (track, language) {
  const trackingData = {
    event: 'navigate',
    componentType: 'exit-pop-up',
    action: 'click',
    title: 'close',
    virtualPageURL: `${language}/exit-pop-up`,
  };

  track({ data: trackingData });
}

export default {
  exitModalPageLoadEvent,
  exitModalSignupLoginBtnClickEvent,
  exitModalLearnMoreClickEvent,
  exitModalCloseEvent,
};
